var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { ALLViewer } from "@@/Annotation";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { SchemaItemType } from "@@/Schema";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { ColorStore } from "../UIComponents/ColorDialog";
import { SelectMemberDialogState } from "../UIComponents/SelectMemberDialog";
export class SchemaDialogState {
    constructor() {
        this.editmode = false;
        this.show = false;
        this.name = "";
        this.apicode = "";
        this.itemindex = 1;
        this.derived = false;
        this.schemaitems = [];
        this.subitemtype = SchemaItemType.Text;
        this.stage = 0;
        this.letrid = "";
        this.editschema = undefined;
        this.saving = false;
        this.custompanelrowshow = false;
        this.custompostshow = false;
        this.custominfopanelshow = false;
        this.customrowcode = "";
        this.custompanelcode = "";
        this.custompostaction = "";
        this.dragging = false;
        this.dragzone = "";
        this.dragginitem = undefined;
        this.activeitemid = "";
        this.activeitem = undefined;
        this.choiceitems = [];
        this.vieweabletoeveryone = true;
        this.smstate = new SelectMemberDialogState();
        this.dateformats = [];
        this.selectedsubitemid = "";
        this.activedatasheet = "";
        this.savingid = "";
        this.derviedschema = "";
        this.showtypesmenu = false;
        this.dialog = new BaseDialogState();
        this.adddialog = new BaseDialogState();
        this.colEditId = "";
        this.editColName = "";
        this.colDeleteId = "";
        this.colorstate = new ColorStore();
        this.rtupdatemap = new Map();
        makeObservable(this);
        this.dialog.setHeaderLabel("Worksheet");
        this.dialog.setCancelLabel("Close");
        this.dialog.setOkLabel("Add");
        this.dialog.setModalSize("6xl");
        this.dialog.onOk = () => {
            this.save();
        };
        this.adddialog.setModalSize("6xl");
        this.adddialog.setHeaderLabel("Worksheet");
        this.adddialog.setCancelLabel("Close");
        this.adddialog.setOkLabel("Add");
        this.adddialog.onOk = () => {
            this.save();
        };
        APPEvent.addSubscriberForAddSchema((sh) => {
            if (this.saving && sh.id === this.savingid) {
                this.setSaving(false);
                if (!sh.sh) {
                    APPEvent.publishApperror("Sorry, failed to store worksheet");
                }
                else {
                    this.setShow(false);
                }
            }
        });
        APPEvent.addSubscriberForUpdateSchema((sc) => {
            this.setSaving(false);
            if (!sc.ok) {
                if (this.colEditId) {
                    APPEvent.publishApperror("Sorry, failed to update column name");
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to update worksheet");
                }
            }
            else {
                this.setColEditId("");
                this.setEditMode(false);
                this.setShow(false);
            }
        });
    }
    setCustomRowPanelShow(show) {
        this.custompanelrowshow = show;
    }
    setCustomRowPostActionShow(show) {
        this.custompostshow = show;
    }
    setCustomInfoPanelShow(show) {
        this.custominfopanelshow = show;
    }
    setEditColName(name) {
        this.editColName = name;
    }
    setColEditId(id) {
        this.colEditId = id;
    }
    setColDeleteId(id) {
        this.colDeleteId = id;
    }
    setStage(st) {
        this.stage = st;
        if (st != 2) {
            this.adddialog.setHideFooter(true);
        }
        else {
            this.adddialog.setHideFooter(false);
        }
    }
    removeItemFromSubList(index, listitem) {
        if (listitem.items && listitem.items.length > index) {
            listitem.items.splice(index, 1);
        }
    }
    addSubItemId(id) {
        this.selectedsubitemid = id;
    }
    addItemToSubItem(type, listitem) {
        if (!listitem.items) {
            listitem.items = [];
        }
        listitem.items.push({
            id: type.id,
            item: type,
            orderindex: listitem.items.length
        });
    }
    setSubItemType(type) {
        this.subitemtype = type;
    }
    setShowTypesMenu(show) {
        this.showtypesmenu = show;
    }
    setDragZone(zid) {
        this.dragzone = zid;
    }
    setViewableToEveryone(viewable) {
        this.vieweabletoeveryone = viewable;
    }
    moveItemBetween(item, min, max) {
        let rannum = Math.random() * (max - min) + min;
        while (rannum === 0) {
            rannum = Math.random() * (max - min) + min;
        }
        item.orderindex = rannum;
    }
    setDervied(derived) {
        this.derived = derived;
    }
    setChoiceItems(items) {
        this.choiceitems.splice(0, this.choiceitems.length);
        this.choiceitems.push(...items);
    }
    setName(name) {
        this.name = name;
    }
    addChoiceItem(item) {
        this.choiceitems.push(item);
    }
    addApiCode(item) {
        this.apicode = item;
    }
    setDervicedSchema(dh) {
        this.derviedschema = dh;
    }
    removeChoiceItem(item) {
        const index = this.choiceitems.indexOf(item);
        if (index > -1) {
            this.choiceitems.splice(index, 1);
        }
    }
    setActiveItemid(id) {
        this.activeitemid = id;
    }
    setActiveItem(item) {
        this.activeitem = item;
    }
    setSaving(saving) {
        this.saving = saving;
    }
    addSchemaItem(item) {
        this.schemaitems.push(item);
    }
    getSchemaItems() {
        return this.schemaitems.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
    }
    removeSchemaItem(item) {
        const index = this.schemaitems.indexOf(item);
        if (index > -1) {
            this.schemaitems.splice(index, 1);
        }
    }
    save(rowupdatereq = []) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        if (!this.name) {
            APPEvent.publishApperror("Please enter name for worksheet");
            return;
        }
        if (this.editmode && !this.editschema) {
            return;
        }
        else {
            if (this.schemaitems.length === 0 && !this.dervivedsch) {
                APPEvent.publishApperror("Minimum one field is needed per worksheet");
                return;
            }
        }
        for (let i = 0; i < this.schemaitems.length; i++) {
            const element = this.schemaitems[i];
            if (element.id === this.colEditId) {
                element.name = this.editColName;
            }
            if (element.type === SchemaItemType.Number) {
                const nel = element;
                if (nel.minvalue && nel.maxvalue) {
                    if (nel.minvalue > nel.maxvalue) {
                        APPEvent.publishApperror("Minimum value is greater than maxmium value for " + element.name);
                        return;
                    }
                }
                if (nel.defaultvalue) {
                    const df = parseFloat(nel.defaultvalue);
                    if (nel.minvalue && df < nel.minvalue) {
                        APPEvent.publishApperror("Default value is greater than minimum value for " + element.name);
                        return;
                    }
                    if (nel.maxvalue && df > nel.maxvalue) {
                        APPEvent.publishApperror("Default value is greater than maxmium value for " + element.name);
                        return;
                    }
                }
            }
            if (element.type === SchemaItemType.Remote) {
                const rf = element;
                if (!rf.did || !rf.sid || !rf.cid) {
                    APPEvent.publishApperror("Remote details missing from " + element.name);
                    return;
                }
            }
            if (element.type === SchemaItemType.Choice) {
                if (element.items !== undefined) {
                    element.items = element.items.filter((it) => it.name.trim() !== '');
                }
            }
            if (element.type === SchemaItemType.Choice &&
                (element.items === undefined || (element.items !== undefined && element.items.length === 0))) {
                APPEvent.publishApperror("Minimum one non empty value is needed for choice item " + element.name);
                return;
            }
            if (element.type === SchemaItemType.ID) {
                const id = element;
                if (id.length < 4) {
                    APPEvent.publishApperror("The length of the ID must be greater than or equal to 4");
                    return;
                }
            }
            if (element.type === SchemaItemType.List) {
                if (element.items === undefined || element.items.length === 0) {
                    APPEvent.publishApperror("Minimum one sub field is needed for list item " + element.name);
                    return;
                }
                const ssitems = element.items;
                for (let j = 0; j < ssitems.length; j++) {
                    const subelement = ssitems[j].item;
                    if (element.id + "----" + subelement.id === this.colEditId) {
                        subelement.name = this.editColName;
                    }
                    if (subelement.type === SchemaItemType.Choice) {
                        if (subelement.items !== undefined) {
                            subelement.items = subelement.items.filter((it) => it.name.trim() !== '');
                        }
                    }
                    if (subelement.type === SchemaItemType.Choice &&
                        (subelement.items === undefined || (subelement.items !== undefined && subelement.items.length === 0))) {
                        APPEvent.publishApperror("Minimum one non empty value is needed for choice item " + subelement.name + " inside list item " + element.name);
                        return;
                    }
                    if (subelement.type === SchemaItemType.Remote) {
                        const rf = subelement;
                        if (!rf.did || !rf.sid || !rf.cid) {
                            APPEvent.publishApperror("Remote details missing from " + element.name);
                            return;
                        }
                    }
                }
            }
        }
        console.log("Saving");
        console.log(this.schemaitems);
        this.setSaving(true);
        let viewers = [ALLViewer];
        if (!this.vieweabletoeveryone) {
            viewers = [];
            for (const sid of this.smstate.selectedcontacts) {
                viewers.push(sid);
            }
        }
        const pks = LetrwingCrypto.getNewKeypair();
        const skh = LetrwingCrypto.generateNewSecretKey();
        const wkyes = {
            shkey: skh,
            priavatekey: pks.privatkey,
            publickey: pks.publickey
        };
        if (this.editschema && !((_a = this.editschema) === null || _a === void 0 ? void 0 : _a.webformkeys)) {
            this.editschema.webformkeys = wkyes;
        }
        const req = {
            apicode: this.apicode,
            templateid: (_c = (_b = this.editschema) === null || _b === void 0 ? void 0 : _b.templateid) !== null && _c !== void 0 ? _c : '',
            parentschema: this.dervivedsch,
            id: this.editmode ? (_e = (_d = this.editschema) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '' : '',
            viewers: viewers,
            items: this.schemaitems,
            letrid: this.letrid,
            accesskey: this.editmode ? (_g = (_f = this.editschema) === null || _f === void 0 ? void 0 : _f.accesskey) !== null && _g !== void 0 ? _g : '' : '',
            nonce: this.editmode ? (_j = (_h = this.editschema) === null || _h === void 0 ? void 0 : _h.nonce) !== null && _j !== void 0 ? _j : '' : '',
            authorid: '',
            lastupdatetime: -1,
            updatedby: '',
            actions: this.editmode ? (_l = (_k = this.editschema) === null || _k === void 0 ? void 0 : _k.actions) !== null && _l !== void 0 ? _l : [] : [],
            datasheetid: this.editmode ? (_o = (_m = this.editschema) === null || _m === void 0 ? void 0 : _m.datasheetid) !== null && _o !== void 0 ? _o : this.activedatasheet : this.activedatasheet,
            name: this.name,
            numberoffset: this.editmode ? (_q = (_p = this.editschema) === null || _p === void 0 ? void 0 : _p.numberoffset) !== null && _q !== void 0 ? _q : Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000 :
                Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000,
            dateoffset: this.editmode ? (_s = (_r = this.editschema) === null || _r === void 0 ? void 0 : _r.dateoffset) !== null && _s !== void 0 ? _s : Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000 :
                Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000,
            metaschemaids: this.editmode ? (_u = (_t = this.editschema) === null || _t === void 0 ? void 0 : _t.metaschemaids) !== null && _u !== void 0 ? _u : [] : [],
            webformbox: { items: this.schemaitems, rules: (_w = (_v = this.editschema) === null || _v === void 0 ? void 0 : _v.rules) !== null && _w !== void 0 ? _w : [] },
            webformkeys: this.editmode && ((_x = this.editschema) === null || _x === void 0 ? void 0 : _x.webformkeys) ? (_y = this.editschema) === null || _y === void 0 ? void 0 : _y.webformkeys : wkyes,
            rules: this.editmode && ((_z = this.editschema) === null || _z === void 0 ? void 0 : _z.rules) ? this.editschema.rules : undefined,
            datarules: this.editmode && ((_0 = this.editschema) === null || _0 === void 0 ? void 0 : _0.datarules) ? this.editschema.datarules : undefined,
            footers: this.editmode && ((_1 = this.editschema) === null || _1 === void 0 ? void 0 : _1.footers) ? this.editschema.footers : undefined,
            viewdepentschemas: this.editmode ? (_2 = this.editschema) === null || _2 === void 0 ? void 0 : _2.viewdepentschemas : undefined,
            barcodecolumnid: this.editmode ? (_3 = this.editschema) === null || _3 === void 0 ? void 0 : _3.barcodecolumnid : "",
            custompanels: this.customrowcode,
            custompanelcode: this.custompanelcode,
            custompostaction: this.custompostaction
        };
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        if (this.colEditId) {
            areq['colEditId'] = this.colEditId;
        }
        else if (this.colDeleteId) {
            areq['colDeleteId'] = this.colDeleteId;
        }
        if (rowupdatereq.length > 0) {
            areq['rowupdatereq'] = rowupdatereq;
        }
        console.log(areq);
        this.savingid = areq.id;
        Apphandler.sendMessage(this.editmode ? 'updateschema' : "addschema", areq);
    }
    createSchema(items) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        let viewers = [ALLViewer];
        if (!this.vieweabletoeveryone) {
            viewers = [];
            for (const sid of this.smstate.selectedcontacts) {
                viewers.push(sid);
            }
        }
        const pks = LetrwingCrypto.getNewKeypair();
        const skh = LetrwingCrypto.generateNewSecretKey();
        const wkyes = {
            shkey: skh,
            priavatekey: pks.privatkey,
            publickey: pks.publickey
        };
        if (this.editschema && !((_a = this.editschema) === null || _a === void 0 ? void 0 : _a.webformkeys)) {
            this.editschema.webformkeys = wkyes;
        }
        const req = {
            apicode: this.apicode,
            parentschema: this.dervivedsch,
            id: this.editmode ? (_c = (_b = this.editschema) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '' : '',
            viewers: viewers,
            items: items,
            letrid: this.letrid,
            accesskey: this.editmode ? (_e = (_d = this.editschema) === null || _d === void 0 ? void 0 : _d.accesskey) !== null && _e !== void 0 ? _e : '' : '',
            nonce: this.editmode ? (_g = (_f = this.editschema) === null || _f === void 0 ? void 0 : _f.nonce) !== null && _g !== void 0 ? _g : '' : '',
            authorid: '',
            lastupdatetime: -1,
            updatedby: '',
            datasheetid: this.editmode ? (_j = (_h = this.editschema) === null || _h === void 0 ? void 0 : _h.datasheetid) !== null && _j !== void 0 ? _j : this.activedatasheet : this.activedatasheet,
            name: this.name,
            numberoffset: this.editmode ? (_l = (_k = this.editschema) === null || _k === void 0 ? void 0 : _k.numberoffset) !== null && _l !== void 0 ? _l : Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000 :
                Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000,
            dateoffset: this.editmode ? (_o = (_m = this.editschema) === null || _m === void 0 ? void 0 : _m.dateoffset) !== null && _o !== void 0 ? _o : Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000 :
                Math.floor(Math.random() * (1000000 - 1000 + 1)) + 1000,
            metaschemaids: this.editmode ? (_q = (_p = this.editschema) === null || _p === void 0 ? void 0 : _p.metaschemaids) !== null && _q !== void 0 ? _q : [] : [],
            webformbox: { items: this.schemaitems, rules: (_s = (_r = this.editschema) === null || _r === void 0 ? void 0 : _r.rules) !== null && _s !== void 0 ? _s : [] },
            webformkeys: this.editmode && ((_t = this.editschema) === null || _t === void 0 ? void 0 : _t.webformkeys) ? (_u = this.editschema) === null || _u === void 0 ? void 0 : _u.webformkeys : wkyes,
            rules: this.editmode && ((_v = this.editschema) === null || _v === void 0 ? void 0 : _v.rules) ? this.editschema.rules : undefined,
            datarules: this.editmode && ((_w = this.editschema) === null || _w === void 0 ? void 0 : _w.datarules) ? this.editschema.datarules : undefined,
            footers: this.editmode && ((_x = this.editschema) === null || _x === void 0 ? void 0 : _x.footers) ? this.editschema.footers : undefined,
            actions: this.editmode && this.editschema ? (_y = this.editschema.actions) !== null && _y !== void 0 ? _y : [] : [],
            custompanels: this.customrowcode,
            custompanelcode: this.custompanelcode,
            custompostaction: this.custompostaction
        };
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.savingid = areq.id;
        Apphandler.sendMessage(this.editmode ? 'updateschema' : "addschema", areq);
    }
    setCustomRowCode(code) {
        this.customrowcode = code;
    }
    setCustomPanelCode(code) {
        this.custompanelcode = code;
    }
    setCustomPostAction(code) {
        this.custompostaction = code;
    }
    reset() {
        this.dervivedsch = undefined;
        this.setShow(false);
        this.setSaving(false);
        this.setActiveItemid("");
        this.setActiveItem(undefined);
        this.setName("");
        this.setViewableToEveryone(true);
        this.smstate.reset();
        this.dateformats.splice(0, this.dateformats.length);
        this.schemaitems.splice(0, this.schemaitems.length);
        this.setEditMode(false);
        this.editschema = undefined;
        this.setDervied(false);
        this.setStage(0);
        this.itemindex = 1;
        this.rtupdatemap = new Map();
        this.setEditColName("");
        this.setCustomRowCode("");
        this.setCustomPanelCode("");
        this.setCustomPostAction("");
        this.setCustomRowPanelShow(false);
        this.setCustomRowPostActionShow(false);
        this.addApiCode("");
    }
    setShow(show) {
        this.show = show;
        if (!this.editmode) {
            this.adddialog.setOpen(show);
        }
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (mode) {
            this.dialog.setOkLabel("Edit");
        }
        else {
            this.dialog.setOkLabel("Add");
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "apicode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "derived", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaDialogState.prototype, "schemaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], SchemaDialogState.prototype, "subitemtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "stage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "custompanelrowshow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "custompostshow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "custominfopanelshow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "customrowcode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "custompanelcode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "custompostaction", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "dragzone", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], SchemaDialogState.prototype, "activeitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "activeitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaDialogState.prototype, "choiceitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "vieweabletoeveryone", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaDialogState.prototype, "dateformats", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "selectedsubitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "derviedschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "showtypesmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "colEditId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "editColName", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaDialogState.prototype, "colDeleteId", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setCustomRowPanelShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setCustomRowPostActionShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setCustomInfoPanelShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setEditColName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setColEditId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setColDeleteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setStage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "removeItemFromSubList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "addSubItemId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "addItemToSubItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setSubItemType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setShowTypesMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setDragZone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setViewableToEveryone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number, Number]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "moveItemBetween", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setDervied", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "addChoiceItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "addApiCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setDervicedSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "removeChoiceItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setActiveItemid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setActiveItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "addSchemaItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "removeSchemaItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "save", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setCustomRowCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setCustomPanelCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setCustomPostAction", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaDialogState.prototype, "setEditMode", null);
